<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OlK0D/tc-custom/9781504095006.jpg?1725723409320" alt="This image is the cover for the book Inspector French and the Starvel Hollow Tragedy, The Inspector French Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Inspector French and the Starvel Hollow Tragedy, The Inspector French Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A deadly house fire causes a fortune to go up in smoke in this classic mystery novel by the author of <i>The Cask</i>.</b></p><p> A tragic fire in Starvel Hollow has left behind a heap of smoldering ruins. An old man and two of his servants were lost in the flames—along with the fortune he kept in cash. With the bodies charred beyond recognition, there’s no reason to suspect foul play . . . until the supposedly incinerated banknotes are discovered in circulation. </p> Scotland Yard Insp. Joseph French has some questions for Ruth Averill, the elderly man’s niece. Ruth’s life was saved on the night of the fire by a chance invitation from friends. But could she have set her uncle’s house aflame? As French peels back the layers of deceit, he uncovers a twisting case of arson, murder, and body snatching . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Freeman Wills Crofts
      </h2>
      
      <p class="authorDescription body article">Freeman Wills Crofts (1879&ndash;1957) was an Irish author of detective fiction. Born in Dublin, he spent decades as a railroad engineer in Northern Ireland. When a long illness kept him away from work, he wrote <I>The Cask</I> (1920), a mystery novel that launched him to immediate popularity. He continued writing after he returned to work, finally leaving the railroad in 1929 to write full time. His best-known novels include <I>The Starvel Hollow Tragedy</I> (1927) and <I>The 12:30 from Croydon</I> (1934).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5aa71b90